import { Colors } from '../scss/common/style';

export const URL = process.env.REACT_APP_API_URL;
export const API_URL = `${URL}/api`;
export const IDENTITY_URL = URL;
export const NUTRIENTS_URL = process.env.REACT_APP_NUTRIENTS_URL;
export const IMAGE_URL = `${URL}/uploads`;
export const CLIENT_ID = 'apiClient';
export const CLIENT_SECRET = 'DFioasdZ324sdf';
export const USDA_KEY = 'Hp5qmMWdVfSerIbLQaof93ssWC0brGKubNfRuHI8';

export const PRODUCTION = URL === 'https://api.stoclio.com';
export const STAGING = URL === 'https://stapi.stoclio.com';

export const UPLOAD_MAX_SIZE_IMAGE = 3000000; // 3MB

export const SUPPORTED_IMAGE_FORMATS = ['image/jpeg', 'image/png'];

export const DEFAULT_SERVINGS = 1;

export const DEFAULT_SERVING_SIZE = 100;

export const SHIPPING_TYPES = {
  AIR: 'Air',
  SEA: 'Sea',
  LAND: 'Land',
};

export const PLACEMENT_TYPES = {
  INSIDE: 'Inside',
  MIDDLE: 'Middle',
  DOOR: 'Door',
};

export const SAMPLE_TYPES = {
  NO_SAMPLE: 'NoSample',
  ONE_PIECE: 'OnePiece',
  TWO_PIECES: 'TwoPieces',
  ONE_BOX: 'OneBox',
  TWO_BOXES: 'TwoBoxes',
};

export const WAREHOUSE_MOVEMENT_TYPES = {
  SEVLIEVO_1: { label: 'Sevlievo1', value: 'Sevlievo1' },
  SEVLIEVO_2: { label: 'Sevlievo2', value: 'Sevlievo2' },
  SEVLIEVO_3: { label: 'Sevlievo3', value: 'Sevlievo3' },
  SEVLIEVO_IMPORT: { label: 'Sevlievo Import', value: 'SevlievoImport' },
  CUSTOMS: { label: 'Customs', value: 'Customs' },
};

export const STATUS_COLORS = {
  WAITING: '#8F0CF5',
  LABELLING: '#EFBB03',
  CONSOLIDATION: '#0F6DF9',
  READY: '#05B40C',
  MISSING: '#D81F21',
};

export const WAREHOUSE_MOVEMENT_STATUS_TYPES = {
  WAITING: { label: 'Waiting', value: 'Waiting', color: STATUS_COLORS.WAITING },
  LABELLING: { label: 'Labelling', value: 'Labelling', color: STATUS_COLORS.LABELLING, DarkText: true },
  CONSOLIDATION: { label: 'Consolidation', value: 'Consolidation', color: STATUS_COLORS.CONSOLIDATION },
  READY: { label: 'Ready', value: 'Ready', color: STATUS_COLORS.READY },
};

export const WAREHOUSE_MOVEMENT_CONDITION_TYPES = {
  NORMAL: { label: 'Normal', value: 'Normal' },
  DAMAGED: { label: 'Damaged', value: 'Damaged' },
  MISSING: { label: 'Missing', value: 'Missing', color: STATUS_COLORS.MISSING },
  SAMPLE: { label: 'Sample', value: 'Sample' },
};

export const PACKAGE_TYPES = {
  CONSUMER_UNIT: 'ConsumerUnit',
  DISTRIBUTION_UNIT: 'DistributionUnit',
  LAYER: 'Layer',
  PALLET: 'Pallet',
  DISPLAY: 'Display',
  OTHER: 'Other',
};

export const TEMPERATURE_CONTROL_TYPES = {
  REEFER: 'Reefer',
  NON_REEFER: 'NonReefer',
};

export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_FORMAT_WITH_TIME = 'DD.MM.YYYY HH:mm';
export const DATE_FORMAT_WITH_TIME_WITH_FRACTION_SECONDS = 'DD.MM.YYYY HH:mm:ss.SSS';
export const DATE_FORMAT_TIME = 'HH:mm:ss';

// client temporarily asked to limit the date range
export const minReportDate = new Date('2023-08-01');
export const maxReportDate = new Date('2028-08-31');

export const FILE_UPLOAD_TYPES = {
  ORDER_EXCEL: 'orderExcel',
  PRODUCT_IMPORTS: 'productImports',
  PRODUCT_SELECTION: 'productSelection',
};

export const WAREHOUSE_LOCATION_CHAMBERS = [
  { label: 'I', value: '1' },
  { label: 'II', value: '2' },
  { label: 'III', value: '3' },
  { label: 'IV', value: '4' },
  { label: 'V', value: '5' },
  { label: 'VI', value: '6' },
  { label: 'VII', value: '7' },
  { label: 'VIII', value: '8' },
  { label: 'IX', value: '9' },
  { label: 'X', value: '10' },
  { label: 'XI', value: '11' },
];

export const WAREHOUSE_LOCATION_COLUMNS = (() => {
  let arr = [];
  for (var i = 1; i <= 30; i++) {
    arr.push({ label: i.toString(), value: i.toString() });
  }
  return arr;
})();

export const WAREHOUSE_LOCATION_LETTERS = [
  { label: 'A', value: 'A' },
  { label: 'B', value: 'B' },
  { label: 'C', value: 'C' },
  { label: 'D', value: 'D' },
  { label: 'E', value: 'E' },
  { label: 'F', value: 'F' },
  { label: 'G', value: 'G' },
  { label: 'H', value: 'H' },
  { label: 'I', value: 'I' },
  { label: 'J', value: 'J' },
];

export const WAREHOUSE_LOCATION_LEVELS = (() => {
  let arr = [];
  for (var i = 1; i <= 5; i++) {
    arr.push({ label: i.toString(), value: i.toString() });
  }
  return arr;
})();

export const ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  ADMIN: 'Admin',
  WAREHOUSE: 'Warehouse',
  WAREHOUSE_ADMIN: 'WarehouseAdmin',
  DATABASE_ADMIN: 'DatabaseAdmin',
  CUSTOMER: 'Customer',
  SALES: 'Sales',
  LABELER: 'Labeler',
  OFFICE: 'Office',
  FNB: 'Fnb',
  WAREHOUSE_EXTERNAL_USER: 'WarehouseExternalUser',
  SVILA_CLIENT_ADMIN: 'SvilaClientAdmin',
  SVILA_CLIENT: 'SvilaClient',
};

export const FNB_STATUS = {
  20: 'Върната', // no
  12: 'Завършена', // no
  11: 'Отхвърлена', // no
  3: 'Доставка', // no
  1: 'Нова', // yes
  2: 'Потвърдена', // yes
  7: 'Обработва се', // yes
  15: 'Очаквана наличност', // yes
};

export const CONSOLIDATION_STATUS = {
  InConsolidation: 'InConsolidation',
  Consolidated: 'Consolidated',
  ConfirmedByOwner: 'ConfirmedByOwner',
  CanceledByOwner: 'CanceledByOwner',
};

export const ORDER_STATUS_COLORS = {
  GoodsNotOrdered: '#ffffff',
  GoodsOrdered: '#fde7cf',
  GoodsReceived: '#d2f6ff',
  GoodsReserved: '#8F0CF5',
  LabellingGoods: '#EFBB03',
  ConsolidatingGoods: '#0F6DF9',
  GoodsReady: '#05B40C',
  GoodsLoaded: '#ff0000',
  GoodsSold: '#6d9bd8',
  GoodsInvoiced: '#362401',
  DocumentsOnProcessing: '#000000',
  DocumentsSent: '#000000',
};

export const SVILA_CLIENT_STATUS = {
  ENABLED: { label: 'Enabled', value: 0 },
  DISABLED: { label: 'Disabled', value: 1 },
};
